import Component from '@glimmer/component';
import fade from 'ember-animated/transitions/fade';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
export default class DeluxePlayerPortraitPlayerComponent extends Component {
  rules({ oldItems, newItems }) {
    return fade;
  }

  textTransition = fade;
  fade = fade;

  @tracked sizing = {};
  @tracked dimensions = {};

  @action
  onContainerSizeChange({ queryResults, dimensions }) {
    next(() => {
      this.sizing = queryResults;
      this.dimensions = dimensions;
    });
  }
}
